import { useSelector } from 'react-redux';
import { LoginApps } from '../../util/loginApps';
import { Config } from '../../util/config';

const useLoginApp = () =>
  useSelector<{ config: Config }, LoginApps>((state) => state.config.loginApp);

export default useLoginApp;
